export enum PanelIndicatorEnum {
    Danger = 'danger',
    Warning = 'warning',
    Waiting = 'waiting',
    Info = 'info',
    Success = 'success',
}

export interface IPanelIndicator {
    indicator: PanelIndicatorEnum;
    className: string;
    iconName: string;
}

export const PanelIndicators: IPanelIndicator[] = [
    {
        indicator: PanelIndicatorEnum.Danger,
        className: 'danger',
        iconName: 'remove_circle',
    },
    {
        indicator: PanelIndicatorEnum.Warning,
        className: 'warning',
        iconName: 'error_outline',
    },
    {
        indicator: PanelIndicatorEnum.Waiting,
        className: 'warning',
        iconName: 'query_builder',
    },
    {
        indicator: PanelIndicatorEnum.Info,
        className: 'info',
        iconName: 'check_circle',
    },
    {
        indicator: PanelIndicatorEnum.Success,
        className: 'success',
        iconName: 'check_circle',
    },
];
